export class KullaniciSubeDuzenleRequest {

  kullaniciId: number;
  subeIdList: number[];

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
